import {
  live_event_script,
  speciality,
  live_event
} from "../../js/path";
import _ from "lodash";

export default {
  data() {
    return {
      pageNo: null,
      table_header: [],
      live_event_script_id: null,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "live_event_title",
          label: "Live Event",
        },
        {
          key: "cron_status",
          label: "Cron Status",
        },
        {
          key: "is_active",
          label: "Status",
        },
        {
          key: "edit",
        },
        {
          key: "delete",
        },
      ],
      params: "",
      filter: null,
      filterOn: [],
      tableData: [],
      sortBy: "id",
      sortDesc: true,
      key: 0,
      activeTab: "all",
      currentPage: 1,
      getLiveEvents: [],
      form: {
        live_event_id: "",
        is_active: 0,
        specialities: [
          { speciality_id: null, count: 0, attendees_count: 0 }
        ],
      },
      speciality: [],
    };
  },
  methods: {
    async fetchSingleSpeciality(id) {
      const url = speciality.specialityUrl;
      const data = await this.getRequest(`${url}/${id}`);
      if (data.status) {
        return data.response; // return single speciality object
      }
      return null;
    },
    
    fetchSpeciality: _.debounce(async function (name) {
      this.$store.commit("loader/updateStatus", true);
      try {
        if (name) {
          const url = speciality.specialityUrl;
          const data = await this.getRequest(`${url}?search=${name}`);
          if (data.status) {
            this.speciality = data.response.data || []; // Always set as array
          }
        }
      } catch (err) {
        console.log(err);
      }
      this.$store.commit("loader/updateStatus", false);
    }, 1000),
    addSpeciality() {
      this.form.specialities.push({
        speciality_id: null,
        count: 0,
        attendees_count: 0
      });
    },
    removeSpeciality(index) {
      if (this.form.specialities.length > 1) {
        this.form.specialities.splice(index, 1);
      }
    },
    async fetchLiveEvent(query) {
        const url = live_event.liveEventUrl;
        const data = await this.getRequest(
          url + "?limit=50&filter=active&search=" + query
        );
        if (data.status) {
          this.getLiveEvents = data.response.data;
        }
      },
      async fetchSingleLiveEvent(link_id) {
        const url = live_event.liveEventUrl;
        const data = await this.getRequest(url + '/' + link_id + '?id=1');
        if (data.status) {
          this.form.live_event_id = data.response;
        }
      },
    search(event) {
      if (this.filter.length > 1) {
        if (event.keyCode == 13) {
          this.fetchData(this.activeTab);
        }
      } else if (this.filter.length == 0) this.fetchData(this.activeTab);
    },
    searchFor() {
      if (this.filter.length > 0) {
        this.fetchData(this.activeTab);
      } else {
        this.fetchData(this.activeTab);
      }
    },
    filterPage() {
      if (this.pageNo.length > 0) {
        this.params = `&page=${this.pageNo}`;
        this.fetchData(this.activeTab);
        this.currentPage = this.pageNo;
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async fetchData(txt) {
      let url = null;
      if (txt == "active") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url =
            live_event_script.live_event_scriptUrl +
            "?filter=" +
            txt +
            "&search=" +
            this.filter;
        } else {
          url = live_event_script.live_event_scriptUrl + "?filter=" + txt;
        }
      } else if (txt == "trash") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url =
            live_event_script.live_event_scriptUrl +
            "?filter=" +
            txt +
            "&search=" +
            this.filter;
        } else {
          url = live_event_script.live_event_scriptUrl + "?filter=" + txt;
        }
      } else if (txt == "all") {
        console.log(txt, "txt");
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          console.log("inside if**");
          url =
            live_event_script.live_event_scriptUrl +
            "?filter=" +
            txt +
            "&search=" +
            this.filter;
        } else {
          console.log("inside else**");
          url = live_event_script.live_event_scriptUrl + "?filter=" + txt;
        }
      }
      url += this.params;
      this.$store.commit("loader/updateStatus", true);
      try {
        const data = await this.getRequest(url);
        if (data.status) {
          const responseData = data.response;
          this.tableData = responseData;
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
      this.key += 1;
    },
    async updateStatus(id) {
      try {
        let index = this.tableData.data.findIndex((e) => e.id === id);
        const url = live_event_script.updateStatus + "/" + id;
        const data = await this.postRequest(url, {
          is_active: !this.tableData.data[index].is_active,
        });
        if (data.status) {
          const responseData = data.response;
          this.tableData.data[index] = responseData;
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
        }
        this.key += 1;
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
    },
    async fetchLive_event_script(id) {
      this.$store.commit("toast/updateStatus", true);
      try {
        let url = live_event_script.live_event_scriptUrl + "/" + id;
        const data = await this.getRequest(url);
        if (data.status) {
          const responseData = data.response;
          if (responseData.specialities?.length > 0) {
            this.form.specialities = await Promise.all(
              responseData.specialities.map(async (item) => {
                const specialityObj = await this.fetchSingleSpeciality(item.speciality_id);
                return {
                  speciality_id: specialityObj || { id: item.speciality_id, title: '' },
                  count: item.count,
                  attendees_count: item.attendees_count
                };
              })
            );
          }
          
          
          
          if (
            responseData.live_event_id != "" &&
            responseData.live_event_id != null
          ) {
            this.form.live_event_id = this.fetchSingleLiveEvent(responseData.live_event_id);
          }
          if (responseData.is_active) {
            this.form.is_active = true;
          }
          this.live_event_script_id = responseData.id;
        }
      } catch (err) {
        console.log(err);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: "Fetching error!",
        });
      }
      this.$store.commit("toast/updateStatus", false);
    },
    async deleteLiveEventScript(id) {
      this.$store.commit("loader/updateStatus", true);
      try {
        let index = this.tableData.data.findIndex((e) => e.id === id);
        const url = live_event_script.live_event_scriptUrl + "/" + id;
        const data = await this.postRequest(url, {
          _method: "DELETE",
        });
        if (data.status) {
          this.tableData.data.splice(index, 1);
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
    },
    async restoreLiveEventScript(id) {
      this.$store.commit("loader/updateStatus", true);
      try {
        let index = this.tableData.data.findIndex((e) => e.id === id);
        const url = live_event_script.restoreLiveEventScript + "/" + id;
        const data = await this.postRequest(url, {});
        if (data.status) {
          this.tableData.data.splice(index, 1);
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
    },
    async submitData() {
      try {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Please Fill The Required Fields",
          });
          return false;
        }
    
        this.$store.commit("loader/updateStatus", true);
    
        // ✅ Build request URL
        let url = live_event_script.live_event_scriptUrl;
        if (this.$route.name === "edit-live-event-script") {
          url = `${live_event_script.live_event_scriptUrl}/${this.live_event_script_id}`;
        }
    
        // ✅ Helper to get ID from object or raw value
        const getId = (val) => (typeof val === "object" && val?.id ? val.id : val);
    
        let dataAppend = new FormData();
    
        // ✅ Append is_active as number
        dataAppend.append("is_active", this.form.is_active ? 1 : 0);
    
        // ✅ Append other form fields, auto-extracting IDs if needed
        for (const key in this.form) {
          if (key !== "is_active" && key !== "specialities") {
            dataAppend.append(key, getId(this.form[key]));
          }
        }
    
        // ✅ Append specialities
        this.form.specialities.forEach((item, index) => {
          if (item.id) {
            dataAppend.append(`specialities[${index}][id]`, item.id);
          }
          dataAppend.append(`specialities[${index}][speciality_id]`, getId(item.speciality_id));
          dataAppend.append(`specialities[${index}][count]`, item.count);
          dataAppend.append(`specialities[${index}][attendees_count]`, item.attendees_count);
        });
    
        // ✅ If editing, append method override
        if (this.$route.name === "edit-live-event-script") {
          dataAppend.append("_method", "put");
        }
    
        // ✅ Send API request
        const data = await this.postRequest(url, dataAppend);
    
        if (data.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
          this.$router.push("/live-event-script");
        }
      } catch (err) {
        console.error(err);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err?.data?.message || "Please try again!",
        });
      } finally {
        this.$store.commit("loader/updateStatus", false);
      }
    },
    
    tabActive() {
      if (this.activeTab == "trash") {
        if (this.table_header.includes("delete")) {
          let index = this.fields.findIndex((item) => item.key == "delete");
          this.fields[index] = {
            key: "restore",
          };
          let table_index = this.table_header.findIndex(
            (item) => item == "delete"
          );
          this.table_header[table_index] = "restore";
        } else {
          this.table_header.push("restore");
          this.fields.push({
            key: "restore",
          });
        }

        if (!this.can("restore-live-event-script")) {
          let index = this.fields.findIndex((item) => item.key == "restore");
          if (index !== -1) {
            this.fields.splice(index, 1);
            let table_index = this.table_header.findIndex(
              (item) => item == "restore"
            );
            this.table_header.splice(table_index, 1);
          }
        }

        let index = this.fields.findIndex((item) => item.key == "edit");
        if (index !== -1) {
          this.fields.splice(index, 1);
          let table_index = this.table_header.findIndex(
            (item) => item == "edit"
          );
          this.table_header.splice(table_index, 1);
        }
      } else {
        if (this.table_header.includes("restore")) {
          if (!this.can("edit-live-event-script")) {
            this.fields[14] = {
              key: "delete",
            };
          } else {
            this.fields[15] = {
              key: "delete",
            };
          }

          let table_index = this.table_header.findIndex(
            (item) => item == "restore"
          );
          this.table_header[table_index] = "delete";
        }

        if (!this.can("edit-live-event-script")) {
          let index = this.fields.findIndex((item) => item.key == "edit");
          if (index !== -1) {
            this.fields.splice(index, 1);
            let table_index = this.table_header.findIndex(
              (item) => item == "edit"
            );
            this.table_header.splice(table_index, 1);
          }
        } else {
          if (!this.table_header.includes("edit")) {
            this.table_header.push("edit");
            this.fields[14] = {
              key: "edit",
            };
          }
        }
        if (!this.can("delete-live-event-script")) {
          let index = this.fields.findIndex((item) => item.key == "delete");
          if (index !== -1) {
            this.fields.splice(index, 1);
            let table_index = this.table_header.findIndex(
              (item) => item == "delete"
            );
            this.table_header.splice(table_index, 1);
          }
        } else {
          if (!this.table_header.includes("delete")) {
            this.table_header.push("delete");
            this.fields[15] = {
              key: "delete",
            };
          }
        }
      }
    },
  },
  watch: {
    currentPage: {
      handler: function (value) {
        if (typeof value != undefined) {
          this.params = `&page=${value}`;
          this.fetchData(this.activeTab);
          this.pageNo = this.currentPage;
        }
      },
    },
    activeTab(v) {
      if (v) this.tabActive();
    },
  },
  created() {
    if (
      this.$route.name == "add-live-event-script" ||
      this.$route.name == "edit-live-event-script"
    ) {
      if (this.$route.name == "edit-live-event-script") {
        this.fetchLive_event_script(this.$route.params.id);
      }
    } else {
      this.fetchData(this.activeTab);
    }
    this.fields.map((item) => {
      this.table_header.push(item.key);
    });
    this.tabActive();
  },
};
